var SPScript = require("spscript");
var cache = require('./cache');

var utils = {};
//static helper methods

utils.isAuthenticated = () => window._spPageContextInfo.systemUserKey;

utils.isWindowsUser = () => window._spPageContextInfo.systemUserKey && window._spPageContextInfo.systemUserKey.indexOf('i:0).w|') !== -1;

utils.isPage = (page) => window.location.href.toLowerCase().indexOf(page.toLowerCase()) > -1

utils.isInIFrame = () => self != top;

utils.getRootDao = () => new SPScript.RestDao(_spPageContextInfo.siteAbsoluteUrl);

utils.getFolderPath = () => "/Style Library/_natptax";

utils.getUserProfile = () => {
	var cacheKey =_spPageContextInfo.systemUserKey ? "profile_" + _spPageContextInfo.systemUserKey : "invalid cache key";
	var cacheVal = cache.get(cacheKey);
	if (!cacheVal){
		return (new SPScript.RestDao()).profiles.current().then(p => {
			console.log(p);
			return cache.set(cacheKey, p);
		});
	} else {
		return Promise.resolve(cacheVal);
	}
};

module.exports = utils;


// WEBPACK FOOTER //
// ./src/scripts/shared/utils.js